// Mirror LogCard/RecentLogsPanel dateLabel rule so blocks in the Cortes editor
// pick up the same recording-date string the source cards show. `start_at`
// arrives from the DB as a timezone-less ISO string but represents UTC — force
// UTC parsing so browsers west of UTC don't render the previous calendar day.
export function formatDateLabel(raw: unknown): string {
  if (raw == null || raw === "") return "";
  let input: string | number | Date = raw as any;
  if (typeof raw === "string") {
    const hasTz = /(Z|[+-]\d{2}:?\d{2})$/.test(raw);
    const isIsoDateTime = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(raw);
    if (isIsoDateTime && !hasTz) input = `${raw}Z`;
  }
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short" });
}

export function pickDateSource(el: Record<string, any>): unknown {
  return el.tcIn ?? el.tcInMs ?? el.start_at ?? el.startAt ?? el.created_at ?? el.createdAt;
}
